import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { queryClient } from "@/lib/queryClient";
import { AppProviders } from "./app-providers";

// Registra Service Worker per cache avanzata
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', {
      scope: '/'
    })
      .then(registration => {
        console.log('SW registered successfully');
        
        // Gestisci gli aggiornamenti del service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // Nuovo service worker disponibile, aggiorna
                  console.log('New service worker available, updating...');
                  newWorker.postMessage({ type: 'SKIP_WAITING' });
                } else {
                  // Service worker installed for first time
                  console.log('Service worker installed for the first time');
                }
              }
            });
          }
        });

        // When a new service worker takes control, no reload needed —
        // the next navigation will use the updated SW automatically.
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          console.log('New service worker activated and controlling the page');
        });
      })
      .catch(registrationError => {
        console.warn('SW registration failed:', registrationError);
      });
  });

  // Clear outdated caches on page load
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      const currentCacheName = 'trieste-storica-v1.6';
      cacheNames.forEach(cacheName => {
        if (cacheName.startsWith('trieste-storica-') && 
            cacheName !== currentCacheName) {
          console.log('Clearing old cache:', cacheName);
          caches.delete(cacheName);
        }
      });
    });
  }
}

// Force light mode: rimuovi classi/storage residui da precedente dark mode
document.documentElement.classList.remove("dark");
document.documentElement.classList.add("light");
try {
  localStorage.removeItem("theme");
  localStorage.removeItem("chakra-ui-color-mode");
} catch {}

const rootEl = document.getElementById("root")!;
const tree = (
  <AppProviders client={queryClient}>
    <App />
  </AppProviders>
);

// Server pre-renderizzato (SSR) → idrata; altrimenti render client classico.
// Per la rotta essay SSR precarichiamo i chunk lazy da cui dipende l'HTML (ChakraProvider,
// essay-detail) PRIMA di hydrateRoot: se il boundary Suspense è ancora sospeso durante
// l'hydration, un qualsiasi update concorrente (es. effetti GTM/i18n, query /api/user) lo
// fa ricadere su client-rendering (React #418/#419). Precaricarli rende l'hydration sincrona.
const isEssayDetailPath = /^\/(?:(?:it|en|de|sl)\/)?approfondimenti\/[^/]+/.test(window.location.pathname);

if (rootEl.hasChildNodes()) {
  if (isEssayDetailPath) {
    void Promise.all([
      import("@/components/chakra/ChakraProvider"),
      import("@/pages/essay-detail"),
      // Lazy fuori dal Suspense delle route ma dentro ChakraBoundary: se il suo
      // chunk manca durante l'hydration sospende l'INTERO boundary → React #421.
      import("@/components/common/CookieConsentBanner"),
    ]).then(() => hydrateRoot(rootEl, tree));
  } else {
    hydrateRoot(rootEl, tree);
  }
} else {
  createRoot(rootEl).render(tree);
}